import styled from 'styled-components'

export const BackButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  min-width: fit-content;
  width: fit-content;
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px solid #d7e0ea;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 10px 24px rgba(45, 116, 156, 0.1);
  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;

  &:hover {
    transform: translateY(-1px);
    background: #f6fafe;
    box-shadow: 0 14px 30px rgba(45, 116, 156, 0.14);
  }
`

export const TextButton = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #2d749c;
  line-height: 1;
`
